import {Provider} from "@angular/core";
import {MODULE_VERSIONS} from "@fedeltapointofsale/data-client";

export const WBOVersion: Provider = {
    provide: MODULE_VERSIONS,
    useValue: {
        "module": "wbo",
        "version": "25.7.1_328"
    },
    multi: true
};
